import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { startWith } from 'rxjs';
import { Permission } from 'src/app/common/enums/permissions';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { SubSink } from 'SubSink'

@Directive({
    selector: '[visibleWithPermissions]',
    standalone: false
})
export class VisibleWithPermissionsDirective implements OnInit, OnDestroy {
    private el = inject(ElementRef);
    private authService = inject(AuthService);

    @Input('visibleWithPermissions') permissions: Permission[];

    private subs = new SubSink();

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() { }
    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    ngOnInit(): void {
        const display = this.el.nativeElement.style.display;

        this.subs.sink = this.authService.isAuthenticated$
            .pipe(startWith(false))
            .subscribe(isAuthenticated => {
                if (!isAuthenticated || !this.permissions.some((p) => this.authService.hasPermission(p))) {
                    this.el.nativeElement.style.display = 'none';
                } else {
                    this.el.nativeElement.style.display = display;
                }
            });
    }
}
